import './Loader.css';

export const Loader: React.FC = () => {
  return (
    <div className="loader"></div>
  );
}